import type { ReactNode } from 'react'
import { Button } from './Button.js'

interface ErrorStateProps {
  title: string
  message?: string | null
  primaryAction?: { label: string; onClick: () => void }
  secondaryAction?: { label: string; onClick: () => void }
  icon?: ReactNode
}

export function ErrorState({
  title,
  message,
  primaryAction,
  secondaryAction,
  icon,
}: ErrorStateProps) {
  return (
    <div className="flex flex-col items-center text-center max-w-sm mx-auto gap-3 animate-fade-in">
      <div
        className="w-14 h-14 rounded-full bg-brand-error-soft text-brand-error flex items-center justify-center text-2xl font-bold"
        aria-hidden
      >
        {icon ?? '!'}
      </div>
      <h2 className="text-lg font-semibold text-brand-text">{title}</h2>
      {message && (
        <p className="text-sm text-brand-text-muted leading-relaxed">
          {message}
        </p>
      )}
      {(primaryAction || secondaryAction) && (
        <div className="flex flex-col gap-2 w-full mt-2">
          {primaryAction && (
            <Button onClick={primaryAction.onClick}>
              {primaryAction.label}
            </Button>
          )}
          {secondaryAction && (
            <Button
              variant="subtle"
              size="sm"
              onClick={secondaryAction.onClick}
            >
              {secondaryAction.label}
            </Button>
          )}
        </div>
      )}
    </div>
  )
}
